export const getWeekNumber = (date) => {
    const tempDate = new Date(date.valueOf());
    const dayNum = (date.getDay() + 6) % 7;
    tempDate.setDate(tempDate.getDate() - dayNum + 3);
    const firstThursday = tempDate.valueOf();
    tempDate.setMonth(0, 1);
    if (tempDate.getDay() !== 4) {
        tempDate.setMonth(0, 1 + ((4 - tempDate.getDay()) + 7) % 7);
    }
    return 2 + Math.ceil((firstThursday - tempDate.valueOf()) / 604800000); // 604800000 = number of milliseconds in a week
}


export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function formatDate(date, seperator = '', withTime = false) {
    let currentTime = '';
    if (withTime) {
        currentTime = ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    }
    return '' + date.getUTCFullYear() + seperator + ('0' + (date.getMonth() + 1)).slice(-2) + seperator + ('0' + date.getDate()).slice(-2) + currentTime;
}


export function changeKw(year, kw) {
    let currDate = getStartDateOfWeek(year, kw);
    const dates = [];
    for (let i = 0; i < 7; i++) {
        const nextDay = new Date(currDate);
        nextDay.setDate(currDate.getDate() + i); // Setzt das Datum für den nächsten Tag
        dates.push(nextDay);
    }
    return dates;
}


export function getStartDateOfWeek(year, week) {
    const firstDayOfYear = new Date(year, 0, 1);
    const firstMonday = new Date(firstDayOfYear);
    const dayOfWeek = firstMonday.getDay();
    const daysToMonday = (dayOfWeek <= 1 ? 1 - dayOfWeek : 8 - dayOfWeek);
    firstMonday.setDate(firstDayOfYear.getDate() + daysToMonday);

    const firstDayOfWeek = new Date(firstMonday);
    firstDayOfWeek.setDate(firstMonday.getDate() + (week - 3) * 7);

    const firstSaturday = new Date(firstDayOfWeek);
    const daysToSaturday = (6 - firstSaturday.getDay()); // 6 = Samstag
    firstSaturday.setDate(firstSaturday.getDate() + daysToSaturday);

    return firstSaturday;
}

export const trimExt = fileName => fileName.indexOf('.') === -1 ? fileName : fileName.split('.').slice(0, -1).join('.');

export function grepDateFromLocalDateString(dateString) {
    const datePattern = /^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{4}/;

    const match = dateString.match(datePattern);
    if (match) {
        return match[0];
    }
}